<template>
    <div class="brt-map-quickModule" ref="quickModule">

        <ul class="top-section" v-if="$store.state.mapStore.isShow(moduleState,[0,1])">
            <li :class = "(index == activeIndex)?'active':''"
                :state=" $BRT.$findCar.timer && item.icon == 'find-car' ? 'border':''"
                @click="selecte(index,item)"  v-for="(item,index) in specialQuick"
                v-if="item.show"><i :class="'iconfont icon-'+item.icon" ></i></li>
        </ul>

        <ul class="bottom-section" v-if="$store.state.mapStore.isShow(moduleState,[1])">
            <li v-for="(item,index) in referrerQuick"><img :src="item.imgUrl"/></li>
        </ul>


        <Dialog v-model="shareVisible" :title="$BRT.$locate.point?'选择分享方式':''">

            <div class="location-tip" v-if="!$BRT.$locate.point">

                <div class="content-box" @click.stop="">当前无定位,可选择目的地进行分享</div>

                <div class="btn-box">
                    <a class="btn">取消</a>
                    <a class="btn" @click.stop="getLocation">
                        <i class="iconfont icon-marker"></i>
                        <span>获取位置</span>
                    </a>
                </div>

            </div>


            <!--<div class="selected-box" v-else>-->

            <!--<div class="box" @click.stop="goSharing">-->

            <!--<div class="icon">-->
            <!--<i class="iconfont icon-coordinates-all"></i>-->
            <!--</div>-->

            <!--<p>共享位置</p>-->
            <!--<p>多人共享实时位置</p>-->

            <!--</div>-->

            <!--<div class="box" @click.stop="sharePoint">-->

            <!--<div class="icon">-->
            <!--<i class="iconfont icon-share"></i>-->
            <!--</div>-->

            <!--<p>分享位置</p>-->
            <!--<p>仅分享当前位置</p>-->

            <!--</div>-->

            <!--</div>-->

        </Dialog>

    </div>
</template>

<script>

    import {Dialog} from '@/components/dialog'

    import {toCreateRoom} from "./../../../../../config/prepare"

    export default {
        name: "QuickModule",
        data(){
            return {

                moduleState:0,

                activeIndex:-1,

                shareVisible:false,

                specialQuick:[
                    {
                        icon:'zhongyingwen1',
                        show:true,
                    },
                    {
                        icon:'fenxiang',
                        show:this.$getEnvironment != 2 ? true : false,
                    },
                    {
                        icon:'gongxiang',
                        show:true,
                    },
                    {
                        icon:'danlan',
                        show:true,
                    },
                    {
                        icon:'find-car',
                        show:this.$mapStore.plugInfo.plugInfo.plugInSettings.queryCarServiceOpen == 1 ? true : false,
                    },
                    {
                        icon:"sheshi1",
                        show:true
                    },
                    {
                        icon:"kongchewei",
                        show:true
                    },
                    {
                        icon:'reli',
                        show:false,//JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.apply).hotMap == 'close' ? false : true
                    },

                    {
                        icon:'all',
                        show:false,
                    }
                ],

                referrerQuick:[
                    {
                        imgUrl:'./images/set.png'
                    },
                    {
                        imgUrl:'./images/set.png'
                    },
                    {
                        imgUrl:'./images/set.png'
                    },
                    {
                        imgUrl:'./images/set.png'
                    },
                    {
                        imgUrl:'./images/set.png'
                    }
                ],
            }
        },

        components:{
            Dialog
        },

        methods:{
            selecte(index,item){

                // this.activeIndex =index;

                if(item.icon == 'all'){

                    this.$BRT.$options.GuideDrawer = true;

                }
                else if(item.icon=='sheshi1'){
                    //切换寻车地图
                    this.$router.replace(`/search`);
                }

                else if(item.icon == 'find-car'){

                    //切换寻车地图
                    this.$router.replace(`/findCar`);
                    //防止干扰
                    if(this.$BRT.$urlParam.findCar.enterType){
                        this.$BRT.$urlParam.findCar.enterType = '';
                    }

                }

                else if(item.icon == 'fenxiang'){

                    if(this.$BRT.$locate.point){
                        this.sharePoint();
                    }else{
                        this.shareVisible = true;
                    }

                }

                else if(item.icon == 'danlan'){

                    this.$router.replace('/classify');

                }

                else if(item.icon == 'zhongyingwen1'){

                    //传递上报批次
                    let url = 'https://p.brtbeacon.net/custom/shenzhen-huizhanzhongxin/en/index.html#/map?v=1';
                    //传递openid
                    if(this.$WXUSERINFO.openid)url += `&openid=${this.$WXUSERINFO.openid}`;

                    if(this.$WXUSERINFO.ai)url += `&userUpdataAi=${this.$WXUSERINFO.ai}`;

                    location.replace(url);

                }

                else if(item.icon == 'gongxiang'){

                    // if(!this.$BRT.$locate.point){
                    //     this.shareVisible = true;
                    // }else{


                        let plugInfo = this.$store.state.mapStore.plugInfo,
                            param = {
                            buildingId:plugInfo.buildingId,
                            token:plugInfo.token
                        };

                        toCreateRoom(param,(res,err)=>{
                            if(!err){
                                let url = `https://p.brtbeacon.net/custom/shenzhen-huizhanzhongxin/share/index.html#/index?roomId=${res}&appId=${plugInfo.appId}&language=ch`;

                                //传递openid
                                if(this.$WXUSERINFO.openid)url += `&openid=${this.$WXUSERINFO.openid}`;

                                //传递上报批次
                                if(this.$WXUSERINFO.ai)url += `&userUpdataAi=${this.$WXUSERINFO.ai}`;

                                location.replace(url);
                            }else {
                                this.$message.info('创建房间失败');
                            }
                        });

                    // }

                }

                else if(item.icon == 'kongchewei'){

                    //开启空车位模式
                    // this.bus.$emit('onParkSpace',{status:1})

                    let point = this.$BRT.$locate.point;

                    if(point){

                        if(point.floor < 0){

                            this.$router.replace('/parking')
                        }

                        else{
                            this.$message.info('请行驶到B1,B2楼使用此功能');
                        }

                    }
                    else{
                        this.$message.info('定位成功才能使用此功能哟~~')
                    }

                }
            },

            goSharing(){//共享
                this.$message.info('暂未上线该功能,敬请期待')
            },
            sharePoint(){//分享定位点

                let $shareInfo={
                    LABEL_X:this.$BRT.$locate.point.x,
                    LABEL_Y:this.$BRT.$locate.point.y,
                    FLOOR_NUMBER:this.$BRT.$locate.point.floor,
                    POI_ID:'location'
                }

                this.bus.$emit('shareCallback',{status:1,shareInfo:$shareInfo})

            },

            getLocation(){//获取定位点
                this.shareVisible = false;
                this.bus.$emit('openLocation');
            }
        },

    }
</script>

<style lang="less">

    @import "QuickModule.less";

</style>
